import React, { useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createPageTags } from 'supporticon/api/pages'
import { persistPageData } from '../../../../store/fundraisingPage'
import { selectAPIParams, selectButtonDefaults, selectTagDefinitions } from '../../../../store/site'
import { renderInput, renderFormFields } from 'supporticon/utils/form'
import { convertToMeters } from 'supporticon/utils/units'
import withForm from 'constructicon/with-form'
import form from './form'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Form from 'constructicon/form'

const Tags = ({
  apiParams = {},
  customSupporterPage,
  form,
  fundraisingPage,
  onNext,
  persistPageData,
  tagDefinitions,
  buttonProps,
  styles
}) => {
  const [status, setStatus] = useState('empty')
  const { goalUom, showGoal } = customSupporterPage.fitness

  const handleSubmit = (e) => {
    e.preventDefault()

    return form.submit()
      .then(data =>
        Promise.resolve()
          .then(() => setStatus('fetching'))
          .then(() => {
            const tagValues = [
              showGoal && {
                tagDefinition: {
                  id: 'DSFitnessGoalTargetMeters',
                  label: 'Fitness Target'
                },
                value: convertToMeters(data.fitnessGoal, goalUom),
                aggregation: [{
                  segment: `page:campaign:${fundraisingPage.campaign}`,
                  measurementDomains: ['all']
                }]
              },
              ...tagDefinitions.map(tag => ({
                tagDefinition: {
                  id: tag.id,
                  label: tag.label
                },
                value: data[tag.id],
                aggregation: [{
                  segment: `page:campaign:${fundraisingPage.campaign}`,
                  measurementDomains: ['all'],
                  timeBox: {
                    notBefore: apiParams.startDateTime,
                    notAfter: apiParams.endDateTime
                  }
                }]
              }))
            ]
              .filter(Boolean)

            return createPageTags({
              slug: fundraisingPage.slug,
              tagValues
            })
              .then(() =>
                persistPageData({
                  fitnessGoal: data.fitnessGoal,
                  tags: tagValues,
                  segmentation: {
                    ...fundraisingPage.segmentation,
                    ...data
                  }
                })
              )
          })
          .then(() => setStatus('fetched'))
          .then(() => onNext())
          .catch(error => {
            setStatus('failed')
            return Promise.reject(error)
          })
      )
  }

  const errors = status === 'failed'
    ? [{ message: 'There was an error updating your profile' }]
    : []

  return (
    <Form
      errors={errors}
      icon={false}
      isLoading={status === 'fetching'}
      noValidate
      onSubmit={handleSubmit}
      styles={styles.form}
      submit='Update'
      submitProps={buttonProps}>
      {renderFormFields(form.fields).map(field => {
        const InputTag = renderInput(field.type)

        return <InputTag key={field.name} {...field} />
      })}
    </Form>
  )
}

const mapState = (state, props) => ({
  ...selectAPIParams(state),
  buttonProps: selectButtonDefaults(state),
  tagDefinitions: selectTagDefinitions(state)
})

const mapDispatch = { persistPageData }

export default compose(
  connect(mapState, mapDispatch),
  withStyles(styles),
  withForm(form)
)(Tags)
